// removed by extract-text-webpack-plugin
module.exports = {"commentWrapper":"X8hfe","commentMarker":"_3I5h8","comment":"_2lpCC","contentWrapper":"_2OpAa","header":"_1d81R","editDate":"_3ywfU","content":"_3vLKi","image":"_3rcX1"};


//////////////////
// WEBPACK FOOTER
// ./app/components/comment/comment.scss
// module id = 1699
// module chunks = 0